module.exports = __webpack_public_path__ + "static/media/generic-pipette-filled.7cd34241.svg";